import { Box } from '@chakra-ui/react';

export const AudioRecorderLiveIcon = () => {
  return (
    <Box
      style={{
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: 'var(--fgDanger)',
      }}
      data-testid="recording-live-icon"
    />
  );
};
